module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!--  css in staticUCs.css  -->\r\n<fieldset class="utilisateur-selecteur-view-size cw-fieldset" style="height: 100%">\r\n  <div class="utilisateur-selecteur-view-size form-group col-12">\r\n    <input type="text" class="criteres utilisateur-selecteur-view-size form-control" value="" />\r\n  </div>\r\n  <div class="table_selecteurref_utilisateur"></div>\r\n</fieldset>\r\n';
}
return __p;
};
